import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { observe } from "@web/util/loading/loading";
import { EmailMessageData } from "@interfaces/dws/email-message";
import { ManageEmailSendingService } from "@services/dws/manage-email-sending.service";

export class ManageEmailSendingDatasource  implements DataSource<EmailMessageData>{

    private manageEmailSendingSubject = new BehaviorSubject<EmailMessageData[]>([]);
    private elementsSubject = new Subject<number>();
    public elementsSubject$: Observable<number> = this.elementsSubject.asObservable();

    constructor(
        private manageEmailSendingService: ManageEmailSendingService
    ) { 
    }

    connect(collectionViewer: CollectionViewer) {
        return this.manageEmailSendingSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer) {
        this.manageEmailSendingSubject.complete();
    }

    loadManageEmailSending(externalEntityId: string, page = 0, count = 999999, isReservationCompleted: boolean,sortBy?: string, ) {
        observe(this.manageEmailSendingService.list(externalEntityId, page, count, sortBy))
            .subscribe(
                s => {
                    const rawArray = Array.isArray(s) ? s : (s as any).content || [];

                    const filtered = rawArray.filter((item: any) =>
                        typeof item.type === 'string' && item.type.includes('to-guest')
                    );

                    const dataArray = filtered.map((item: any) => ({
                        ...item,
                        emailActions: this.computeActions(item.sendAt, item.processedAt, item.type, item.id, isReservationCompleted)
                    }));

                    const totalElements = filtered.length;

                    this.manageEmailSendingSubject.next(dataArray);
                    this.elementsSubject.next(Number(totalElements));
                },
                 e => console.error(e));
    }

    private computeActions(sendAt: string, processedAt: string, type: string, emailMessageId: number, isReservationCompleted: boolean) {
        let reservationType = null;
        const parts = type.replace("reservation-", "").split("-");
        reservationType = parts.slice(0, 3).join("-");
        if (processedAt && processedAt === "1970-01-01T00:00:00") {
            if (new Date(sendAt) > new Date()) {
                return [
                { id: "reactivate", name: "Reactivate", type: type, emailMessageId: emailMessageId},
                ];
            } else {
                return [
                { id: "send-manually", name: "Send Manually", type: type, emailMessageId: emailMessageId}
                ];
            }   
        } else if (new Date(sendAt) > new Date()) {
            if (isReservationCompleted) {
                if (reservationType === "feedback-to-guest") {
                    return [
                    { id: "re-send", name: "Re-send", type: type, emailMessageId: emailMessageId},
                    { id: "deactivate", name: "Deactivate", type: type, emailMessageId: emailMessageId}
                    ];
                } else {
                    return [
                    { id: "re-send", name: "Re-send", type: type, emailMessageId: emailMessageId},
                    { id: "deactivate", name: "Deactivate", type: type, emailMessageId: emailMessageId}
                    ];
                }
            } else {
                return [
                { id: "re-send", name: "Re-send", type: type, emailMessageId: emailMessageId},
                { id: "deactivate", name: "Deactivate", type: type, emailMessageId: emailMessageId}
                ]; 
            }
        } else {
            if (isReservationCompleted) {
                if (reservationType === "feedback-to-guest") {
                    return [
                    { id: "re-send", name: "Re-send", type: type, emailMessageId: emailMessageId}
                    ];
                } else {
                    return [
                    { id: "no-action", name: "No actions available", type: type, emailMessageId: emailMessageId}
                    ];
                }
            }
            return [
            { id: "re-send", name: "Re-send", type: type, emailMessageId: emailMessageId }
            ];
        }
    }

    deactivateEmailMessage(emailMessageId: number): Observable<void> {
        return this.manageEmailSendingService.cancel(emailMessageId);
    }

    reactivateEmailMessage(emailMessageId: number): Observable<void> {
        return this.manageEmailSendingService.reactivate(emailMessageId);
    }

}